export default __webpack_public_path__ + "static/media/Studio Display Front View Mockup.9698085b.png";